import React, { Component } from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>
        Academy Hacks, we put you in control of your lessons© 2021.
        HackAcademy.com
      </p>
    </footer>
  );
};
export default Footer;
